
























import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BInputGroup } from 'bootstrap-vue';
import { BFormInput } from 'bootstrap-vue';
import { BButton } from 'bootstrap-vue';
import { uniqueId } from 'underscore';

// TODO: Like in `EmailInput`, `v-model` is broken for this component; there is
//       no `password` prop. The whole initialPassword/password business is
//       janky and unnecessary, as well. This can be majorly simplified. It's
//       used in a lot of places, though, so I'm not going to touch it in the PR
//       that introduces this comment.

library.add(faEye);
library.add(faEyeSlash);

export default Vue.extend({
  name: 'PasswordInput',

  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'b-input-group': BInputGroup,
    'b-form-input': BFormInput,
    'b-button': BButton
  },

  model: {
    prop: 'password',
    event: 'input'
  },

  props: {
    initialPassword: {
      type: String,
      default: ''
    },

    autocomplete: {
      type: String,
      default: 'on'
    },

    placeholder: {
      type: String,
      default: 'Password'
    },

    hasFocus: {
      type: Boolean,
      default: false
    },

    validateImmediately: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showPassword: false,
      password: this.initialPassword,
      passwordValid: false,
      passwordValidated: false
    };
  },

  computed: {
    eyeIcon(): string {
      if (this.showPassword) {
        return 'eye';
      }
      return 'eye-slash';
    },

    id(): string {
      return uniqueId('password');
    },

    passwordType(): string {
      if (this.showPassword) {
        return 'text';
      }
      return 'password';
    },

    showPasswordError(): boolean {
      return this.password.length > 0 && this.passwordValidated === true && this.passwordValid === false;
    }
  },

  mounted(): void {
    if (this.hasFocus) {
      (this.$refs['password-input'] as BFormInput).focus();
    }

    if (this.validateImmediately) {
      if (this.password) {
        this.validatePassword();
      } else {
        this.passwordValid = false;
        this.$emit('password-valid-update', false);
      }
    }
  },

  methods: {
    passwordToggle(_e: Event) {
      this.showPassword = !this.showPassword;
    },

    passwordUpdated(_e: Event) {
      this.$emit('password-update', this.password);
      this.validatePassword();
    },

    validatePassword() {
      this.passwordValid = this.password.length >= 6 ? true : false;
      this.passwordValidated = true;
      this.$emit('password-valid-update', this.passwordValid);
    }
  }
});
